export const GIPHY_API_KEY = 'dc6zaTOxFJmzC';



/** WEBPACK FOOTER **
 ** ./src/constants/globals.js
 **/